<template>
  <div class="home">
    <van-nav-bar title="按摩放松预约" placeholder fixed />
    <van-notice-bar
      left-icon="volume-o"
      text="预约成功请在开始时间后的10分钟内启动设备，否则按照爽约处理。如需取消预约，请至少提前30min。"
    />
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item>
        <img src="@/assets/banner1.png" alt="">
      </van-swipe-item>
      <van-swipe-item>
        <img src="@/assets/banner2.png" alt="">
      </van-swipe-item>
      <van-swipe-item>
        <img src="@/assets/banner3.png" alt="">
      </van-swipe-item>
    </van-swipe>
    <van-divider>预约列表</van-divider>
    <van-empty v-show="aptList.length === 0" description="暂无预约记录或未登录" />

    <van-cell-group>
      <van-cell
        v-for="item in aptList" :key="item.id"
        :title="getDeviceName(item.device_id)"
        :label="item.apt_date +' '+item.time_slot.start_time + '-' + item.time_slot.end_time"
        :to="'apt-detail/'+item.id"
        is-link
      >
        <van-tag :type="getStatusType(item.status)">
          {{ getStatusText(item.status) }}
        </van-tag>
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
import { getUserApts, getAllDevices } from '@/api/home'

export default {
  name: 'HomeIndex',
  components: {},
  data () {
    return {
      aptList: [],
      deviceList: []
    }
  },
  methods: {
    // 获取预约列表
    async getAppointmentsList () {
      const res = await getUserApts()
      // 根据状态排序，确保 confirmed 排在最前面，pending 其次
      this.aptList = res.data.sort((a, b) => {
        const priorityMap = {
          confirmed: 1,
          pending: 2,
          completed: 3,
          cancelled: 4,
          no_show: 5
        }
        return priorityMap[a.status] - priorityMap[b.status]
      })
    },
    // 获取设备列表
    async getDevicesList () {
      const res = await getAllDevices()
      this.$store.commit('home/setDeviceList', res.data)
      this.deviceList = res.data
    },
    // 获取设备名称
    getDeviceName (deviceId) {
      const device = this.deviceList.find(item => item.did === deviceId)
      return device ? device.name : ''
    },

    // ***** 新增方法开始 *****

    /**
     * @description 根据状态获取中文文本
     * @param {string} status 状态码 (e.g. 'pending')
     */
    getStatusText (status) {
      const statusMap = {
        pending: '待开始',
        confirmed: '已确认',
        completed: '已完成',
        cancelled: '已取消',
        no_show: '用户未到'
      }
      return statusMap[status] || '未知'
    },

    /**
     * @description 根据状态获取 Vant Tag 的类型
     * @param {string} status 状态码
     */
    getStatusType (status) {
      const typeMap = {
        pending: 'warning', // 待开始 (黄色)
        confirmed: 'primary', // 已确认 (蓝色)
        completed: 'success', // 已完成 (绿色)
        cancelled: 'default', // 已取消 (灰色)
        no_show: 'danger' // 用户未到 (红色)
      }
      return typeMap[status] || 'default'
    }
    // ***** 新增方法结束 *****

  },
  computed: {
    isLogin () {
      return this.$store.getters.token
    }
  },
  async created () {
    if (!this.isLogin) {
      this.$dialog.confirm({
        title: '尚未登录',
        message: '是否跳转到登录页面？'
      })
        .then(() => {
          // on confirm
          this.$router.push('/login')
        })
        .catch(() => {
          // on cancel
        })
    } else {
      await this.getAppointmentsList()
      const deviceList = this.$store.getters['home/getDeviceList']
      if (deviceList.length === 0) {
        await this.getDevicesList()
      } else {
        this.deviceList = deviceList
      }
    }
  }
}
</script>

<style lang="less" scoped>
// 分类导航部分
.my-swipe .van-swipe-item {
  height: 185px;
  color: #fff;
  font-size: 20px;
  text-align: center;
  background-color: #39a9ed;
}
.my-swipe .van-swipe-item img {
  width: 100%;
  height: 185px;
}

// 主会场
.main img {
  display: block;
  width: 100%;
}

// 猜你喜欢
.guess .guess-title {
  height: 40px;
  line-height: 40px;
  text-align: center;
}

// 商品样式
.goods-list {
  background-color: #f6f6f6;
}
</style>
